import './Footer.css'

const Footer = () => {
  return (
    <footer>
        <h3>Direitos Autorais - @PedroDeVvV</h3>
    </footer>
  )
}

export default Footer